// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.is-sticky {
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 999;
}

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.is-static {
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 999;
}

:host ::ng-deep .navbar-dark .navbar-nav .nav-link {
  color: white !important;
}

:host ::ng-deep .navbar-light .navbar-nav .nav-link {
  color: #6b6f82 !important;
}

.dropdown-menu .dropdown-submenu>a:after {
  top: 14px;
}

.dropdown .dropdown-menu {
  min-width: 13rem !important;
}

.navbar-horizontal .dropdown-menu .dropdown-submenu>a:after,
.navbar-horizontal .dropdown-menu .dropdown-submenu>button:after {
  right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/navigation/horizontalnav/horizontalnav.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf","sourcesContent":[".is-sticky {\n  width: 100%;\n  position: fixed;\n  top: 0px;\n  z-index: 999;\n}\n\n.container {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.is-static {\n  width: 100%;\n  position: sticky;\n  top: 0px;\n  z-index: 999;\n}\n\n:host ::ng-deep .navbar-dark .navbar-nav .nav-link {\n  color: white !important;\n}\n\n:host ::ng-deep .navbar-light .navbar-nav .nav-link {\n  color: #6b6f82 !important;\n}\n\n.dropdown-menu .dropdown-submenu>a:after {\n  top: 14px;\n}\n\n.dropdown .dropdown-menu {\n  min-width: 13rem !important;\n}\n\n.navbar-horizontal .dropdown-menu .dropdown-submenu>a:after,\n.navbar-horizontal .dropdown-menu .dropdown-submenu>button:after {\n  right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
